import LanguageDetector from 'i18next-browser-languagedetector';
import { normalizeLanguage } from './language';

class SupportedLanguageDetector extends LanguageDetector {
  detect(detectionOrder) {
    const detectedLanguages = super.detect(detectionOrder);

    if (Array.isArray(detectedLanguages)) {
      return detectedLanguages.map(normalizeLanguage).filter(Boolean);
    }

    return normalizeLanguage(detectedLanguages);
  }

  cacheUserLanguage(language, caches) {
    const normalizedLanguage = normalizeLanguage(language);

    if (normalizedLanguage) {
      super.cacheUserLanguage(normalizedLanguage, caches);
    }
  }
}

export default SupportedLanguageDetector;



// WEBPACK FOOTER //
// ./src/utils/SupportedLanguageDetector.js